import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    ViewChild,
    ViewChildren,
    ViewEncapsulation,
} from "@angular/core";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { ReportItem } from "../../../model/analytics/report-item";
import { Dataset } from "../../../model/dataset/dataset";
import { ReportType } from "../../../model/analytics/report-type";
import { AggregateReportComponent } from "./aggregate-report/aggregate-report.component";
import { isEnabled } from "../../../../environments/environment";
import { DatapointsFilterService } from "../datapoints-filter.service";
import { DownloadReportItem } from "../../../model/download/item/download-report-item";
import { DownloadService } from "../../../data-access-layer/download/download.service";
import { DownloadDatapointRequest } from "../../../model/download/download-datapoint-request";
import { DownloadFileType } from "../../../model/download/download-file-type";
import { DownloadReportRequest } from "../../../model/download/download-report-request";
import { AttachmentUtils } from "../../../core/utils/attachment-utils";
import { NotifService } from "../../../core/notification/notif.service";
import { AnayticsConstants, Constants } from "../../../constants";
import { CountReportComponent } from "./count-report/count-report.component";
import { RankingReportComponent } from "./ranking-report/ranking-report.component";
import { RandomUtils } from "../../../core/utils/random-utils";
import { ReportComponent } from "./report.component";
import { ReportDisplayType } from "../../../model/analytics/report-display-type";
import { DialogComponent } from "../../../shared/dialog/dialog.component";
import { DialogModel } from "../../../model/dialog/dialog-model";
import { take } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { WorkspaceItemService } from "../../../data-access-layer/workspace-item/workspace-item.service";
import { WorkspaceItemAccess } from "../../../model/workspace/workspace-item-access";
import { WorkspaceItemType } from "../../../model/workspace/workspace-item-type";
import { WorkspaceItem } from "../../../model/workspace/workspace-item";
import { UserStateService } from "../../../auth/user-state-service";
import { WorkspaceItemDialogComponent } from "../../workspace-item/projection/workspace-item-dialog.component";
import { DatasetField } from "../../../model/dataset/field/dataset-field";
import { Functionalities } from "../../../../environments/app-functionalities";
import { DataPointsServiceState } from "../../../shared/services/datapoints-service-state";
import { UpdateWorkspaceItemRequest } from "src/app/model/workspace/update-workspace-item-request";
import { isUndefined } from "src/app/core/utils/util-master";
import { ChartDisplayType } from "src/app/model/analytics/chart-display-type";
import { TreeStructureUtils } from "src/app/core/utils/tree-structure-utils";
import { GroupService } from "src/app/data-access-layer/groups/group.service";
import { GroupTreeNode } from "src/app/model/overlay/group/group-with-overlays-tree-node";
import { Group } from "src/app/model/group/group";
import { DatapointsPageStateService } from "../datapoints-page-state.service";
import { TreeStructure } from "src/app/model/menu/tree-structure";
import { AnalyticsUtils } from "src/app/core/analytics/analytics-utils";
import { decodeHtmlText } from "src/app/core/utils/util-master";

const IS_PART_OF = Functionalities.ANALYTICS;

@Component({
    selector: "map-datapoints-analytics",
    templateUrl: "./datapoints-analytics.component.html",
    styleUrls: ["./datapoints-analytics.component.scss"],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatapointsAnalyticsComponent implements OnInit {
    isEnabled = isEnabled(IS_PART_OF);
    _nriFields: any;
    _climateOverlays: any;

    @ViewChildren(AggregateReportComponent)
    aggregateReportComponents: AggregateReportComponent[];
    @ViewChildren(CountReportComponent)
    countReportComponents: CountReportComponent[];
    @ViewChildren(RankingReportComponent)
    rankingReportComponents: RankingReportComponent[];
    @ViewChild("workspaceItemDialog", { static: true })
    workspaceIemDialog: WorkspaceItemDialogComponent;

    @Input() dataset: Dataset;

    dashboardWorkspaceItems: WorkspaceItem[] = [];

    get nriFields(): any {
        return this._nriFields;
    }
    @Input() set nriFields(nriFields: any) {
        this._nriFields = JSON.parse(JSON.stringify(nriFields));
    }
    get climateOverlays(): any {
        return this.climateOverlays;
    }
    @Input() set climateOverlays(climateOverlays: any) {
        this._climateOverlays = JSON.parse(JSON.stringify(climateOverlays));
    }
    @Input() isDashboardCall: boolean = false;
    @Input()  isComparisonModeActivated: boolean = false;

    reportItems: ReportItem[] = [];
    workspaceItems: WorkspaceItem[] = [];
    comparisonWorkspaceItems: WorkspaceItem[] = [];
    activeWorkspaceItems: WorkspaceItem[] = [];
    openDataTreeStrcuture = new TreeStructureUtils();
    openDatatreeControl = this.openDataTreeStrcuture.getTreeControl();
    openDatadataSource = this.openDataTreeStrcuture.getDataSource();
    openData: boolean = false;

    formulas: WorkspaceItem[] = [];
    selectedReportId: number;


    groups: Group[];
    groupsStrcuture: TreeStructure[];

    constructor(
        private readonly changeDetector: ChangeDetectorRef,
        private readonly datapointsFilterService: DatapointsFilterService,
        private readonly downloadService: DownloadService,
        private readonly notifService: NotifService,
        private readonly workspaceItemService: WorkspaceItemService,
        private readonly datapointsStateService: DataPointsServiceState,
        private readonly userStateService: UserStateService,
        public readonly dialog: MatDialog,
        private readonly datapointsPageState: DatapointsPageStateService,
        private readonly groupService: GroupService
    ) {}

    ngOnInit() {
        this.datapointsStateService.emitOnAnalyticsInit();
        this.initialize();
    }

    initialize(): void {
        this.fetchWorkspaceItems();
        this.fetchComparisonWorkspaceItems();
        this.fetchDashboardWorkspaceItems();
        this.fetchGroups();
    }

    fetchGroups(): Promise<void> {
        return new Promise((resolve) => {
            this.groupService
                .getGroupsAsTree(this.dataset.id, this.dataset.accountID)
                .subscribe((groups) => {
                    this.groups = this.extractChildrenOnly(groups);
                });
            this.groupService.getGroups(this.dataset.id, this.dataset.accountID).subscribe(response => {
                const data = JSON.parse(JSON.stringify(response));
                this.groupsStrcuture = AnalyticsUtils.transformTreeStructure(data);
                resolve();
            });
        });
    }

    extractChildrenOnly(nodes: GroupTreeNode[]): Group[] {
        let groups: Group[] = [];

        const extract = (nodes: GroupTreeNode[]) => {
            for (const node of nodes) {
                if (!node?.children?.length) {
                    groups.push({ ...node.value, isChecked: false });
                } else {
                    extract(node.children);
                }
            }
        };

        extract(nodes);

        return groups;
    }

    addCountReport() {
        this.selectedReportId = 0;
        this.reportItems.push({
            id: RandomUtils.generateUUID(),
            type: ReportType.COUNT,
        });
        this.changeDetector.detectChanges();
    }

    addAggregateReport() {
        this.selectedReportId = 0;
        this.reportItems.push({
            id: RandomUtils.generateUUID(),
            type: ReportType.AGGREGATE,
        });
        this.changeDetector.detectChanges();
    }

    addAverageReport() {
        this.selectedReportId = 0;
        this.reportItems.push({
            id: RandomUtils.generateUUID(),
            type: ReportType.AVERAGE,
        });
        this.changeDetector.detectChanges();
    }

    addRankingReport() {
        this.selectedReportId = 0;
        this.reportItems.push({
            id: RandomUtils.generateUUID(),
            type: ReportType.RANKING,
        });
        this.changeDetector.detectChanges();
    }

    get ReportType() {
        return ReportType;
    }

    removeReportItem(position: number) {
        this.reportItems.splice(position, 1);
    }

    removeAllReports() {
        this.reportItems = [];
        this.isComparisonModeActivated = false;
        this.changeDetector.detectChanges();
    }

    /**
     * Handle drag and drop event to reorder reports
     * Maintains the sequence for download operations
     */
    onReportDrop(event: CdkDragDrop<ReportItem[]>) {
        if (event.previousIndex !== event.currentIndex) {
            moveItemInArray(this.reportItems, event.previousIndex, event.currentIndex);
            this.changeDetector.detectChanges();
        }
    }

    // TODO: i don't think this is necessary anymore
    // onReportClick(report: ReportItem) {
    //     this.reportItems.forEach(reportItem => reportItem.isSelected = false);
    //     report.isSelected = true;
    // }

    downloadReports() {
        let downloadItems: DownloadReportItem[] = [];
        let reportHasTwoDimensionPieChart = false;

        this.reportItems.forEach((reportItem) => {
            let aggregateReportComponent = this.aggregateReportComponents.find(
                (aggregateComp) => aggregateComp.uuid === reportItem.id
            );
            let countReportComponent = this.countReportComponents.find(
                (countComp) => countComp.uuid === reportItem.id
            );
            let rankingReportComponent = this.rankingReportComponents.find(
                (rankingComp) => rankingComp.uuid === reportItem.id
            );

            let component: ReportComponent =
                aggregateReportComponent ||
                countReportComponent ||
                rankingReportComponent;
            if (component) {
                if (
                    component.getDisplayType() ===
                        ReportDisplayType.PIE_CHART &&
                    component.isTwoDimensionReport()
                ) {
                    reportHasTwoDimensionPieChart = true;
                }
                let reportDownloadRequest: DownloadReportItem =
                    component.getReportDownloadRequest();
                if (reportDownloadRequest) {
                    downloadItems.push(reportDownloadRequest);
                }
            }
        });

        let reportRequest: DownloadReportRequest = {
            items: downloadItems,
        };

        let downloadRequest: DownloadDatapointRequest = {
            reportRequest: reportRequest,
            filter: this.datapointsFilterService.getActiveFilter(),
            timezone: Constants.DEFAULT_TIMEZONE,
            dateFormat: Constants.DEFAULT_DATE_FORMAT,
            outputFileType: DownloadFileType.XLSX,
        };

        if (reportHasTwoDimensionPieChart) {
            const dialogRef = this.dialog.open(DialogComponent, {
                data: new DialogModel(
                    "Confirm Download",
                    `Your pie chart has multiple criteria, but the spreadsheet download will only display one. We recommend downloading the bar charts instead.`,
                    "Cancel",
                    "Download"
                ),
            });
            dialogRef
                .afterClosed()
                .pipe(take(1))
                .subscribe((dialogResult) => {
                    if (dialogResult) {
                        this.downloadReportFile(downloadRequest);
                    }
                });
        } else {
            this.downloadReportFile(downloadRequest);
        }
    }

    resetWidgets(){
        this.reportItems = [];
    }

    private downloadReportFile(downloadRequest: DownloadDatapointRequest) {
        this.downloadService
            .downloadDatapoints(
                this.dataset.id,
                downloadRequest,
                "Analytics.xlsx"
            )
            .subscribe(
                (response) => {
                    AttachmentUtils.downloadFileWithName(
                        response,
                        "Analytics.xlsx"
                    );
                },
                (error) =>
                    this.notifService.error(
                        "Something went wrong during download"
                    )
            );
    }

    get WorkspaceItemType() {
        return WorkspaceItemType;
    }

    fetchActiveWorkspaceItems(){
        if(!this.isComparisonModeActivated){
            this.fetchWorkspaceItems();
        } else {
            this.fetchComparisonWorkspaceItems();
        }
    }

    fetchWorkspaceItems(): Promise<void> {
        this.workspaceItemService
            .getAllWorkspaceItemsForUser(
                this.dataset.id,
                WorkspaceItemType.ANALYTICS
            )
            .subscribe((items) => {
                this.workspaceItems = this.addDeletableKey(items);
                this.updateOpenDatadataSource(this.workspaceItems);
            });

        return new Promise((resolve) => {
            this.workspaceItemService
                .getAllWorkspaceItemsForUser(
                    this.dataset.id,
                    WorkspaceItemType.FORMULA
                )
                .subscribe((items) => {
                    this.formulas = items.map(item => ({
                        ...item,
                        name: decodeHtmlText(item.name)
                    }));
                    resolve();
                });
        });
    }

    fetchComparisonWorkspaceItems() {
        this.workspaceItemService
            .getAllWorkspaceItemsForUser(
                this.dataset.id,
                WorkspaceItemType.ANALYTICS_COMPARISON
            )
            .subscribe((items) => {
                this.comparisonWorkspaceItems = this.addDeletableKey(items);
                if(this.isComparisonModeActivated){
                    this.updateOpenDatadataSource(this.comparisonWorkspaceItems);
                }
            });
    }

    addDeletableKey(items){
        items.forEach((item) => {
            if (
                this.userStateService.isSuperadmin ||
                this.userStateService.isAccountAdmin(
                    this.dataset.accountID
                )
            ) {
                item.isDeletable = true;
            } else {
                if (item.access === WorkspaceItemAccess.MEMBER) {
                    item.isDeletable = true;
                }
            }
        });

        return items;
    }

    updateOpenDatadataSource(items) {
        this.openDatadataSource.data = items.map((item) => ({
            data: item.data,
            name: item.name,
            isDeletable: item.isDeletable,
            id: item.id,
        }));
        this.changeDetector.detectChanges();
    }

    applyWorkspaceItem(item: WorkspaceItem) {
        // Update the Open dropdown to show the correct list based on comparison mode
        if (this.isComparisonModeActivated) {
            this.updateOpenDatadataSource(this.comparisonWorkspaceItems);
        } else {
            this.updateOpenDatadataSource(this.workspaceItems);
        }

        // Ensure formulas are loaded before applying (to get latest formula data)
        const formulasLoaded = this.formulas && this.formulas.length > 0;

        // For comparison mode, ensure groups are loaded before applying
        if (this.isComparisonModeActivated && !this.groupsStrcuture) {
            this.fetchGroups().then(() => {
                if (!formulasLoaded) {
                    this.fetchWorkspaceItems().then(() => {
                        this.applyWorkspaceItemInternal(item);
                    });
                } else {
                    this.applyWorkspaceItemInternal(item);
                }
            });
        } else {
            if (!formulasLoaded) {
                this.fetchWorkspaceItems().then(() => {
                    this.applyWorkspaceItemInternal(item);
                });
            } else {
                this.applyWorkspaceItemInternal(item);
            }
        }
    }

    private applyWorkspaceItemInternal(item: WorkspaceItem) {
        this.selectedReportId = item.id;
        this.reportItems = JSON.parse(item.data);
        this.changeDetector.detectChanges();
        this.reportItems.forEach((report) => {
            switch (report.type) {
                case ReportType.AGGREGATE: {
                    let aggregateReportComponent =
                        this.aggregateReportComponents.find(
                            (component) =>
                                !component.getSelectedAggregateField() &&
                                !component.getSelectedFormula()
                        );
                    if (aggregateReportComponent) {
                        aggregateReportComponent.isComparisonModeActivated = this.isComparisonModeActivated;
                        if (report.selectedAggregateField) {
                            aggregateReportComponent.setSelectedAggregateField(
                                report.selectedAggregateField
                            );
                        }
                        if (report.selectedFormula) {
                            aggregateReportComponent.setSelectedFormula(
                                report.selectedFormula
                            );
                        }
                        if (report.selectedBreakdownFieldsByDataset) {
                            let selectedBreakdownFieldsByDataset = new Map<
                                string,
                                DatasetField[]
                            >();
                            for (let k of Object.keys(
                                report.selectedBreakdownFieldsByDataset
                            )) {
                                selectedBreakdownFieldsByDataset.set(
                                    k,
                                    report.selectedBreakdownFieldsByDataset[k]
                                );
                            }
                            aggregateReportComponent.setSelectedBreakdownFieldsByDataset(
                                selectedBreakdownFieldsByDataset
                            );
                        }
                        aggregateReportComponent.sort = report.sort;
                        aggregateReportComponent.reportName = decodeHtmlText(report.name);
                        aggregateReportComponent.reportSubType = isUndefined(
                            report.reportSubType
                        )
                            ? ReportDisplayType.TABLE
                            : report.reportSubType;
                        aggregateReportComponent.chartDisplayType = isUndefined(
                            report.chartDisplayType
                        )
                            ? ChartDisplayType.NONE
                            : report.chartDisplayType;
                        if (
                            (report.selectedAggregateField ||
                                report.selectedFormula) &&
                            report.selectedBreakdownFieldsByDataset
                        ) {
                            aggregateReportComponent.generateReport();
                        }

                        if(this.isComparisonModeActivated) {
                            // aggregateReportComponent._compareGroups = this.getSelectedGroup(report.compareGroupId);
                            // aggregateReportComponent._withGroups = this.getSelectedGroup(report.withGroupId);
                            aggregateReportComponent._compareGroupsStrcuture = AnalyticsUtils.getSelectedStrucutureGroup(report.compareGroupId, this.groupsStrcuture);
                            aggregateReportComponent._withGroupsStrcuture = AnalyticsUtils.getSelectedStrucutureGroup(report.withGroupId, this.groupsStrcuture);
                        }
                        aggregateReportComponent.generateReport();
                    }

                    break;
                }
                case ReportType.RANKING: {
                    let rankingReportComponent =
                        this.rankingReportComponents.find(
                            (component) =>
                                !component.getSelectedRankingField() &&
                                !component.getSelectedFormula()
                        );

                    if (rankingReportComponent) {
                        rankingReportComponent.isComparisonModeActivated = this.isComparisonModeActivated;
                        if (report.selectedRankingField) {
                            // ⭐ NEW: Read overlay ID from embedded field.datasetId property
                            rankingReportComponent.setSelectedRankingField(
                                report.selectedRankingField,
                                report.selectedRankingField.datasetId
                            );
                        }
                        if (report.selectedFormula) {
                            rankingReportComponent.setSelectedFormula(
                                report.selectedFormula
                            );
                        }
                        if (report.selectedFields) {
                            rankingReportComponent.setSelectedFields(
                                report.selectedFields
                            );
                        }
                        // ⭐ NEW: Restore selectedFieldsByDataset Map (climate overlay fields for columns)
                        if (report.selectedFieldsByDataset) {
                            let selectedFieldsByDataset = new Map<
                                string,
                                DatasetField[]
                            >();
                            for (let k of Object.keys(
                                report.selectedFieldsByDataset
                            )) {
                                selectedFieldsByDataset.set(
                                    k,
                                    report.selectedFieldsByDataset[k]
                                );
                            }
                            rankingReportComponent.setSelectedFieldsByDataset(
                                selectedFieldsByDataset
                            );
                        }
                        if (report.noOfItems) {
                            rankingReportComponent.noOfItems = report.noOfItems;
                        }
                        rankingReportComponent.sort = report.sort;
                        rankingReportComponent.reportName = decodeHtmlText(report.name);
                        rankingReportComponent.reportSubType = isUndefined(
                            report.reportSubType
                        )
                            ? ReportDisplayType.TABLE
                            : report.reportSubType;
                        rankingReportComponent.chartDisplayType = isUndefined(
                            report.chartDisplayType
                        )
                            ? ChartDisplayType.NONE
                            : report.chartDisplayType;
                        if (
                            (report.selectedRankingField ||
                                report.selectedFormula) &&
                            report.selectedFields
                        ) {
                            if(this.isComparisonModeActivated) {
                                // rankingReportComponent._compareGroups = this.getSelectedGroup(report.compareGroupId);
                                // rankingReportComponent._withGroups = this.getSelectedGroup(report.withGroupId);
                                rankingReportComponent._compareGroupsStrcuture = AnalyticsUtils.getSelectedStrucutureGroup(report.compareGroupId, this.groupsStrcuture);
                                rankingReportComponent._withGroupsStrcuture = AnalyticsUtils.getSelectedStrucutureGroup(report.withGroupId, this.groupsStrcuture);
                            }
                            rankingReportComponent.generateReport();
                        }
                    }

                    break;
                }
                case ReportType.COUNT: {
                    let countReportComponent = this.countReportComponents.find(
                        (component) =>
                            !component.getSelectedFieldsByDataset().size
                    );

                    if (countReportComponent) {
                        countReportComponent.isComparisonModeActivated = this.isComparisonModeActivated;
                        if (report.selectedFieldsByDataset) {
                            let selectedFieldsByDataset = new Map<
                                string,
                                DatasetField[]
                            >();
                            for (let k of Object.keys(
                                report.selectedFieldsByDataset
                            )) {
                                selectedFieldsByDataset.set(
                                    k,
                                    report.selectedFieldsByDataset[k]
                                );
                            }
                            countReportComponent.setSelectedFieldsByDataset(
                                selectedFieldsByDataset
                            );
                            countReportComponent.sort = report.sort;
                            countReportComponent.reportName = decodeHtmlText(report.name);
                            countReportComponent.reportSubType = isUndefined(
                                report.reportSubType
                            )
                                ? ReportDisplayType.TABLE
                                : report.reportSubType;
                            countReportComponent.chartDisplayType = isUndefined(
                                report.chartDisplayType
                            )
                                ? ChartDisplayType.NONE
                                : report.chartDisplayType;

                            if(this.isComparisonModeActivated) {
                                // countReportComponent._compareGroups = this.getSelectedGroup(report.compareGroupId);
                                // countReportComponent._withGroups = this.getSelectedGroup(report.withGroupId);
                                countReportComponent._compareGroupsStrcuture = AnalyticsUtils.getSelectedStrucutureGroup(report.compareGroupId, this.groupsStrcuture);
                                countReportComponent._withGroupsStrcuture = AnalyticsUtils.getSelectedStrucutureGroup(report.withGroupId, this.groupsStrcuture);
                            }
                            countReportComponent.generateReport();
                        }
                    }

                    break;
                }
                case ReportType.AVERAGE: {
                    let averageReportComponent =
                        this.aggregateReportComponents.find(
                            (component) =>
                                !component.getSelectedAggregateField() &&
                                !component.getSelectedFormula()
                        );
                    if (averageReportComponent) {
                        averageReportComponent.reportType = ReportType.AVERAGE;
                        averageReportComponent.isComparisonModeActivated = this.isComparisonModeActivated;
                        if (report.selectedAggregateField) {
                            averageReportComponent.setSelectedAggregateField(
                                report.selectedAggregateField
                            );
                        }
                        if (report.selectedFormula) {
                            averageReportComponent.setSelectedFormula(
                                report.selectedFormula
                            );
                        }
                        if (report.selectedBreakdownFieldsByDataset) {
                            let selectedBreakdownFieldsByDataset = new Map<
                                string,
                                DatasetField[]
                            >();
                            for (let k of Object.keys(
                                report.selectedBreakdownFieldsByDataset
                            )) {
                                selectedBreakdownFieldsByDataset.set(
                                    k,
                                    report.selectedBreakdownFieldsByDataset[k]
                                );
                            }
                            averageReportComponent.setSelectedBreakdownFieldsByDataset(
                                selectedBreakdownFieldsByDataset
                            );
                        }
                        averageReportComponent.sort = report.sort;
                        averageReportComponent.reportName = decodeHtmlText(report.name);
                        averageReportComponent.reportSubType = isUndefined(
                            report.reportSubType
                        )
                            ? ReportDisplayType.TABLE
                            : report.reportSubType;
                        averageReportComponent.chartDisplayType = isUndefined(
                            report.chartDisplayType
                        )
                            ? ChartDisplayType.AVERAGE
                            : report.chartDisplayType;
                        if (
                            (report.selectedAggregateField ||
                                report.selectedFormula) &&
                            report.selectedBreakdownFieldsByDataset
                        ) {
                            averageReportComponent.generateReport();
                        }

                        if(this.isComparisonModeActivated) {
                            averageReportComponent._compareGroupsStrcuture = AnalyticsUtils.getSelectedStrucutureGroup(report.compareGroupId, this.groupsStrcuture);
                            averageReportComponent._withGroupsStrcuture = AnalyticsUtils.getSelectedStrucutureGroup(report.withGroupId, this.groupsStrcuture);
                        }
                        averageReportComponent.generateReport();
                    }

                    break;
                }
            }
        });
    }

    getSelectedGroup(checkedGroups) {
        const _groups = JSON.parse(JSON.stringify(this.groups)).map((group) => {
            if(checkedGroups.includes(group.id)){
                group.isChecked = true;
            } else {
                group.disabled = true;
            }
            return group;
        });
        return _groups;
    }

    deleteWorkspaceItem(item: WorkspaceItem) {
        const dialogRef = this.dialog.open(DialogComponent, {
            data: new DialogModel(
                "Confirm Action",
                `Are you sure you want to delete "${item.name}"?`
            ),
        });
        dialogRef
            .afterClosed()
            .pipe(take(1))
            .subscribe((dialogResult) => {
                if (dialogResult) {
                    this.workspaceItemService
                        .deleteWorkspaceItem(item.id)
                        .subscribe(
                            (success) => {
                                this.fetchActiveWorkspaceItems();
                                this.notifService.success(
                                    "Item was deleted successfully"
                                );
                            },
                            (error) =>
                                this.notifService.error(error.error.message)
                        );
                }
            });
    }

    saveWorkspaceItem() {
        this.prepareWorkspaceItemInfo();
        this.workspaceIemDialog.open(
            this.reportItems,
            this.getActiveAnalyticType(),
            true
        );
    }

    saveAsWorkspaceItem() {
        this.prepareWorkspaceItemInfo();
        this.workspaceIemDialog.open(
            this.reportItems,
            this.getActiveAnalyticType(),
            false
        );
    }

    getActiveAnalyticType(){
        return !this.isComparisonModeActivated ? WorkspaceItemType.ANALYTICS : WorkspaceItemType.ANALYTICS_COMPARISON;
    }

    private prepareWorkspaceItemInfo() {
        this.reportItems.forEach((report) => {
            switch (report.type) {
                case ReportType.AGGREGATE:
                    let aggregateReportComponent =
                        this.aggregateReportComponents.find(
                            (component) => component.uuid === report.id
                        );
                    if (aggregateReportComponent.getSelectedFormula()) {
                        report.selectedFormula =
                            aggregateReportComponent.getSelectedFormula();
                    } else {
                        report.selectedAggregateField =
                            aggregateReportComponent.selectedAggregateField;
                    }

                    report.selectedAggregateField =
                        aggregateReportComponent.selectedAggregateField;
                    let jsonObject = {};
                    aggregateReportComponent.selectedBreakdownFieldsByDataset.forEach(
                        (value, key) => {
                            jsonObject[key] = value;
                        }
                    );
                    report.selectedBreakdownFieldsByDataset = jsonObject;
                    report.sort = aggregateReportComponent.getSort();
                    report.name = aggregateReportComponent.reportName;
                    report.reportType = aggregateReportComponent.reportType;
                    report.reportSubType =
                        aggregateReportComponent.reportSubType;
                    report.chartDisplayType =
                        aggregateReportComponent.chartDisplayType;
                    if(this.isComparisonModeActivated) {
                        report.compareGroupId = [AnalyticsUtils.getSelectedNodes(aggregateReportComponent._compareGroupsStrcuture)[0].id];
                        report.withGroupId = [AnalyticsUtils.getSelectedNodes(aggregateReportComponent._withGroupsStrcuture)[0].id];
                    }
                    break;
                case ReportType.RANKING:
                    let rankingReportComponent =
                        this.rankingReportComponents.find(
                            (component) => component.uuid === report.id
                        );
                    if (rankingReportComponent.getSelectedFormula()) {
                        report.selectedFormula =
                            rankingReportComponent.getSelectedFormula();
                    } else {
                        report.selectedRankingField =
                            JSON.parse(JSON.stringify(rankingReportComponent.selectedRankingField));

                        // ⭐ NEW: Embed overlay dataset ID directly in the field object
                        if (rankingReportComponent.selectedRankingFieldOverlay) {
                            report.selectedRankingField.datasetId =
                                rankingReportComponent.selectedRankingFieldOverlay.id;
                        }
                    }
                    report.selectedFields =
                        rankingReportComponent.selectedFields;
                    // ⭐ NEW: Save selectedFieldsByDataset Map (climate overlay fields for columns)
                    let rankingJsonObject2 = {};
                    rankingReportComponent.selectedFieldsByDataset.forEach(
                        (fields, datasetId) => {
                            // Deep clone fields and add datasetId to each
                            const fieldsWithDatasetId = fields.map(field => {
                                const fieldCopy = JSON.parse(JSON.stringify(field));
                                fieldCopy.datasetId = datasetId;
                                return fieldCopy;
                            });
                            rankingJsonObject2[datasetId] = fieldsWithDatasetId;
                        }
                    );
                    report.selectedFieldsByDataset = rankingJsonObject2;
                    report.sort = rankingReportComponent.getSort();
                    report.noOfItems = rankingReportComponent.noOfItems;
                    report.name = rankingReportComponent.reportName;
                    report.reportType = rankingReportComponent.reportType;
                    report.reportSubType = rankingReportComponent.reportSubType;
                    report.chartDisplayType =
                        rankingReportComponent.chartDisplayType;
                    if(this.isComparisonModeActivated) {
                    //     report.compareGroupId = rankingReportComponent._compareGroups.filter((group) => group.isChecked).map((group) => {
                    //         return group.id;
                    //     })
                    //     report.withGroupId = rankingReportComponent._withGroups.filter((group) => group.isChecked).map((group) => {
                    //         return group.id;
                    //     });
                    report.compareGroupId = [AnalyticsUtils.getSelectedNodes(rankingReportComponent._compareGroupsStrcuture)[0].id];
                        report.withGroupId = [AnalyticsUtils.getSelectedNodes(rankingReportComponent._withGroupsStrcuture)[0].id];
                    }
                    break;
                case ReportType.AVERAGE:
                    let averageReportComponent =
                        this.aggregateReportComponents.find(
                            (component) => component.uuid === report.id
                        );
                    if (averageReportComponent.getSelectedFormula()) {
                        report.selectedFormula =
                            averageReportComponent.getSelectedFormula();
                    } else {
                        report.selectedAggregateField =
                            averageReportComponent.selectedAggregateField;
                    }

                    report.selectedAggregateField =
                        averageReportComponent.selectedAggregateField;
                    let averageJsonObject = {};
                    averageReportComponent.selectedBreakdownFieldsByDataset.forEach(
                        (value, key) => {
                            averageJsonObject[key] = value;
                        }
                    );
                    report.selectedBreakdownFieldsByDataset = averageJsonObject;
                    report.sort = averageReportComponent.getSort();
                    report.name = averageReportComponent.reportName;
                    report.reportType = averageReportComponent.reportType;
                    report.reportSubType =
                        averageReportComponent.reportSubType;
                    report.chartDisplayType =
                        averageReportComponent.chartDisplayType;
                    if(this.isComparisonModeActivated) {
                        report.compareGroupId = [AnalyticsUtils.getSelectedNodes(averageReportComponent._compareGroupsStrcuture)[0].id];
                        report.withGroupId = [AnalyticsUtils.getSelectedNodes(averageReportComponent._withGroupsStrcuture)[0].id];
                    }
                    break;
                case ReportType.COUNT:
                    let countReportComponent = this.countReportComponents.find(
                        (component) => component.uuid === report.id
                    );
                    let countJsonObject = {};
                    countReportComponent.selectedFieldsByDataset.forEach(
                        (value, key) => {
                            countJsonObject[key] = value;
                        }
                    );
                    report.selectedFieldsByDataset = countJsonObject;
                    report.sort = countReportComponent.getSort();
                    report.name = countReportComponent.reportName;
                    report.reportType = countReportComponent.reportType;
                    report.reportSubType = countReportComponent.reportSubType;
                    report.chartDisplayType =
                        countReportComponent.chartDisplayType;
                    if(this.isComparisonModeActivated) {
                        // report.compareGroupId = countReportComponent._compareGroups.filter((group) => group.isChecked).map((group) => {
                        //     return group.id;
                        // })
                        // report.withGroupId = countReportComponent._withGroups.filter((group) => group.isChecked).map((group) => {
                        //     return group.id;
                        // });
                        report.compareGroupId = [AnalyticsUtils.getSelectedNodes(countReportComponent._compareGroupsStrcuture)[0].id];
                        report.withGroupId = [AnalyticsUtils.getSelectedNodes(countReportComponent._withGroupsStrcuture)[0].id];
                    }
                    break;
            }
        });
    }

    fetchDashboardWorkspaceItems() {
        this.workspaceItemService
            .getAllWorkspaceItemsForUser(
                this.dataset.id,
                WorkspaceItemType.DASHBOARD
            )
            .subscribe((items) => {
                this.dashboardWorkspaceItems = items;
                this.dashboardWorkspaceItems.forEach((item) => {
                    if (
                        this.userStateService.isSuperadmin ||
                        this.userStateService.isAccountAdmin(
                            this.dataset.accountID
                        )
                    ) {
                        item.isDeletable = true;
                    } else {
                        if (item.access === WorkspaceItemAccess.MEMBER) {
                            item.isDeletable = true;
                        }
                    }
                });
            });
    }

    getActiveDasboardType(){
        return !this.isComparisonModeActivated ? WorkspaceItemType.DASHBOARD : WorkspaceItemType.ANALYTICS_DASHBOARD_COMPARISON;
    }

    saveWorkspaceItemForDashboard(i: number) {
        const dashboardReportItem = [];
        dashboardReportItem.push(
            this.prepareSpecificWorkspaceItemInfo(this.reportItems[i])
        );

        this.workspaceIemDialog.open(
            dashboardReportItem,
            this.getActiveDasboardType(),
            true,
            true
        );
    }

    saveAsWorkspaceItemForDashboard(i: number) {
        const dashboardReportItem = [];
        dashboardReportItem.push(
            this.prepareSpecificWorkspaceItemInfo(this.reportItems[i])
        );

        this.workspaceIemDialog.open(
            dashboardReportItem,
            this.getActiveDasboardType(),
            false,
            true
        );
    }

    private prepareSpecificWorkspaceItemInfo(report) {
        switch (report.type) {
            case ReportType.AGGREGATE:
                let aggregateReportComponent =
                    this.aggregateReportComponents.find(
                        (component) => component.uuid === report.id
                    );
                if (aggregateReportComponent.getSelectedFormula()) {
                    report.selectedFormula =
                        aggregateReportComponent.getSelectedFormula();
                }
                report.selectedAggregateField =
                    aggregateReportComponent.selectedAggregateField;
                let jsonObject = {};
                aggregateReportComponent.selectedBreakdownFieldsByDataset.forEach(
                    (value, key) => {
                        jsonObject[key] = value;
                    }
                );
                report.sort = aggregateReportComponent.getSort();
                report.selectedBreakdownFieldsByDataset = jsonObject;
                report.name = aggregateReportComponent.reportName;
                report.reportType = aggregateReportComponent.reportType;
                report.reportSubType = aggregateReportComponent.reportSubType;
                report.chartDisplayType =
                    aggregateReportComponent.chartDisplayType;
                if(this.isComparisonModeActivated) {
                    report.compareGroupId = [AnalyticsUtils.getSelectedNodes(aggregateReportComponent._compareGroupsStrcuture)[0].id];
                    report.withGroupId = [AnalyticsUtils.getSelectedNodes(aggregateReportComponent._withGroupsStrcuture)[0].id];
                }
                break;
            case ReportType.RANKING:
                let rankingReportComponent = this.rankingReportComponents.find(
                    (component) => component.uuid === report.id
                );
                if (rankingReportComponent.getSelectedFormula()) {
                    report.selectedFormula =
                        rankingReportComponent.getSelectedFormula();
                } else {
                    report.selectedRankingField =
                        JSON.parse(JSON.stringify(rankingReportComponent.selectedRankingField));

                    // ⭐ NEW: Embed overlay dataset ID directly in the field object
                    if (rankingReportComponent.selectedRankingFieldOverlay) {
                        report.selectedRankingField.datasetId =
                            rankingReportComponent.selectedRankingFieldOverlay.id;
                    }
                }
                report.selectedFields = rankingReportComponent.selectedFields;
                // ⭐ NEW: Save selectedFieldsByDataset Map (climate overlay fields for columns)
                // Embed datasetId in each field
                let rankingJsonObject = {};
                rankingReportComponent.selectedFieldsByDataset.forEach(
                    (fields, datasetId) => {
                        // Deep clone fields and add datasetId to each
                        const fieldsWithDatasetId = fields.map(field => {
                            const fieldCopy = JSON.parse(JSON.stringify(field));
                            fieldCopy.datasetId = datasetId;
                            return fieldCopy;
                        });
                        rankingJsonObject[datasetId] = fieldsWithDatasetId;
                    }
                );
                report.selectedFieldsByDataset = rankingJsonObject;
                report.sort = rankingReportComponent.getSort();
                report.noOfItems = rankingReportComponent.noOfItems;
                report.name = rankingReportComponent.reportName;
                report.reportType = rankingReportComponent.reportType;
                report.reportSubType = rankingReportComponent.reportSubType;
                report.chartDisplayType =
                    rankingReportComponent.chartDisplayType;
                if(this.isComparisonModeActivated) {
                    report.compareGroupId = [AnalyticsUtils.getSelectedNodes(rankingReportComponent._compareGroupsStrcuture)[0].id];
                    report.withGroupId = [AnalyticsUtils.getSelectedNodes(rankingReportComponent._withGroupsStrcuture)[0].id];
                }
                break;
            case ReportType.COUNT:
                let countReportComponent = this.countReportComponents.find(
                    (component) => component.uuid === report.id
                );
                let countJsonObject = {};
                countReportComponent.selectedFieldsByDataset.forEach(
                    (value, key) => {
                        countJsonObject[key] = value;
                    }
                );
                report.sort = countReportComponent.getSort();
                report.selectedFieldsByDataset = countJsonObject;
                report.name = countReportComponent.reportName;
                report.reportType = countReportComponent.reportType;
                report.reportSubType = countReportComponent.reportSubType;
                report.chartDisplayType = countReportComponent.chartDisplayType;
                if(this.isComparisonModeActivated) {
                    report.compareGroupId = [AnalyticsUtils.getSelectedNodes(countReportComponent._compareGroupsStrcuture)[0].id];
                    report.withGroupId = [AnalyticsUtils.getSelectedNodes(countReportComponent._withGroupsStrcuture)[0].id];
                }
                break;
            case ReportType.AVERAGE:
                let averageReportComponent =
                    this.aggregateReportComponents.find(
                        (component) => component.uuid === report.id
                    );

                if (averageReportComponent.getSelectedFormula()) {
                    report.selectedFormula =
                        averageReportComponent.getSelectedFormula();
                }
                report.selectedAggregateField =
                    averageReportComponent.selectedAggregateField;
                let averageJsonObject = {};
                averageReportComponent.selectedBreakdownFieldsByDataset.forEach(
                    (value, key) => {
                        averageJsonObject[key] = value;
                    }
                );
                report.sort = averageReportComponent.getSort();
                report.selectedBreakdownFieldsByDataset = averageJsonObject;
                report.name = averageReportComponent.reportName;
                report.reportType = averageReportComponent.reportType;
                report.reportSubType = averageReportComponent.reportSubType;
                report.chartDisplayType =
                    averageReportComponent.chartDisplayType;

                if(this.isComparisonModeActivated) {
                    report.compareGroupId = [AnalyticsUtils.getSelectedNodes(averageReportComponent._compareGroupsStrcuture)[0].id];
                    report.withGroupId = [AnalyticsUtils.getSelectedNodes(averageReportComponent._withGroupsStrcuture)[0].id];
                }
                break;
        }

        return report;
    }

    saveSorting(report) {
        if (this.selectedReportId !== 0) {
            this.updateWorkspaceItemName(report);
        }
    }

    updateWorkspaceItemName(reportData) {
        let report = this.workspaceItems.find(
            (element) => element.id === this.selectedReportId
        );
        if (report !== undefined) {
            let data = JSON.parse(report.data);
            if (data.length) {
                data.forEach((element) => {
                    if (element.id == reportData.id) {
                        element.sort = reportData.sort;
                    }
                });
            }
            let request: UpdateWorkspaceItemRequest = {
                id: report.id,
                data: JSON.stringify(data),
                access: report.access,
                name: report.name,
            };
            this.workspaceItemService.updateWorkspaceItem(request).subscribe(
                (success) => {},
                (error) => this.notifService.error(error.error.message)
            );
        } else {
            console.log("report data not found.");
        }
    }

    truncateName(name: string): string {
        if (name.length >= 15) {
            return name.substring(0, 13) + "...";
        }
        return name;
    }

    changeComparisonMode() {
        this.isComparisonModeActivated = !this.isComparisonModeActivated;
        this.reportItems = [];

        if(!this.isComparisonModeActivated){
            this.updateOpenDatadataSource(this.workspaceItems);
        } else {
            this.updateOpenDatadataSource(this.comparisonWorkspaceItems);
        }
    }

    getTooltipForComparisonToggle() {
        return !this.isComparisonModeActivated
            ? "Activate comparison mode"
            : "Deactivate comparison mode";
    }
}
